<template>
  <div id="app" class="bg-primary">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-lg-offset-3">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/lib/font-awesome.min.css";
import "@/assets/css/lib/themify-icons.css";
import "@/assets/css/lib/bootstrap.min.css";
import "@/assets/css/lib/unix.css";
import "@/assets/css/style.css";

export default {
  components: {}
};
</script>
<style scoped>
#app {
  min-height: 100vh;
}
</style>
